import { findThreshold } from '../utils/PRIVATE_meterUtils';
import { Threshold } from '../utils/UNSAFE_meterUtils';
import { useDatatip } from '../hooks/PRIVATE_useDatatip';

type Props = {
  max: number;
  value: number;
  isDisabled?: boolean;
  datatip?: string;
  thresholds?: Threshold[];
  width: number;
  isReadonly?: boolean;
};

export function useRatingDatatip({
  max,
  value,
  isDisabled,
  isReadonly,
  datatip,
  thresholds,
  width
}: Props) {
  const datatipIndex = Math.max(1, Math.ceil(value));
  const offset = ((datatipIndex - Math.ceil(max / 2)) * width) / max;

  const datatipText =
    !datatip && thresholds && !isDisabled
      ? findThreshold(value, thresholds)?.accessibleLabel
      : datatip;

  const { datatipContent, datatipProps } = useDatatip({
    content: isDisabled || isReadonly ? null : datatipText,
    anchor: 'element',
    offset: {
      mainAxis: 8, // redwood datatip design spec
      crossAxis: offset
    },
    placement: 'bottom'
  });

  return {
    datatipContent,
    datatipProps:
      isReadonly && !isDisabled
        ? {
            'aria-describedby': undefined
          }
        : datatipProps
  };
}
